var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTenderhubBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 962,
    height: 797,
    viewBox: "0 0 962 797",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M871.331 661.686L620.805 420.872L460.829 796.889L416.577 415.44L-2.63105e-05 494.627L431.626 236.752L299.567 -23.5675L533.159 116.622L724.654 -206.105L671.005 114.407L1037.92 -38.2559L766.482 216.908L1045.69 300.25L753.941 332.297L871.331 661.686Z",
    fill: "url(#paint0_linear_376_2635)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_376_2635",
    x1: 1016.31,
    y1: -28.2879,
    x2: 207.166,
    y2: 273.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#115EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#115EF3",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenderhubBg);
export default __webpack_public_path__ + "static/media/tenderhub-bg.b9a9cf67f4386db1de069c43dd0b1b30.svg";
export { ForwardRef as ReactComponent };